import React, { useState } from 'react';
import { FormattedMessage } from '../../../../util/reactIntl';
import { EditComponent } from '..';
import { disciplinesWithDropBoxes } from '../../../../util/disciplines';
import css from './SectionDisciplines.css';

import ScoreBadge from '../../../../components/ScoreBadge/ScoreBadge';
import { experienceAllowedOptions } from '../../../../marketplace-custom-config';
import { ProgressBarLevels } from '../../../../components';
import classNames from 'classnames';

const SectionDisciplines = props => {
    const { publicData, isOwnListing, editParams, isMobile, scoreData, isDraftVariant } = props;

    const [hoveredIndex, setHoveredIndex] = useState(null);

    const { desiredDisciplines, starredDisciplines = [] } = publicData || {};
    const [mainDiscipline] = starredDisciplines;

    const noData = !desiredDisciplines || desiredDisciplines.length == 0;

    const editAllowed = isOwnListing && !isDraftVariant;

    if (noData) return null;

    const options = desiredDisciplines
        .reduce((acc, discipline) => {
            const neededObject = disciplinesWithDropBoxes.find(({ id }) => id === discipline);
            if (!neededObject) {
                return acc;
            }

            const isMain = discipline === mainDiscipline;

            const { dropBoxes, label: title } = neededObject;
            const { mainDropBoxEntity, levelDropBoxEntity } = (dropBoxes || []).reduce(
                (acc, entity) => {
                    if (entity.key === 'main') acc.mainDropBoxEntity = entity;
                    if (entity.key === 'level') acc.levelDropBoxEntity = entity;

                    return acc;
                },
                {}
            );

            const targetDropBox = mainDropBoxEntity;
            const chipsKey = levelDropBoxEntity ? levelDropBoxEntity.name : null;
            const chipsValue = chipsKey ? publicData[chipsKey] : null;
            const extraValuesKey = targetDropBox?.name ?? null;
            const dictionaryExtraValue = (targetDropBox?.options || []).reduce(
                (acc, option) => ({ ...acc, [option.value]: option.name }),
                {}
            );
            const rawValues = publicData?.[extraValuesKey];

            const extraValuesOptions =
                Array.isArray(rawValues) && dictionaryExtraValue
                    ? rawValues
                          .map(extraValueId => dictionaryExtraValue[extraValueId] || null)
                          .filter(Boolean)
                    : [];
            const extraValuesOptionsAvailable =
                extraValuesOptions && extraValuesOptions.length > 0 && extraValuesOptions[0];

            const { label, grade: level } =
                experienceAllowedOptions.find(({ key }) => key === chipsValue) || {};

            return [
                ...acc,
                {
                    isMain,
                    label,
                    level,
                    title,
                    extraValuesOptionsAvailable,
                    extraValuesOptions,
                },
            ];
        }, [])
        .sort((a, b) => {
            /** first goes main disc... */
            if (b.isMain) return 1;
            if (a.isMain) return -1;
            /** ...then disc with the highest level */
            return b.level - a.level;
        });

    return (
        <div className={css.root}>
            <h2
                className={classNames(css.title, {
                    [css.titleWithScore]: scoreData && scoreData.baseScoreBreakdown,
                })}
            >
                <FormattedMessage id={`SectionDisciplines.title${isMobile ? 'Mobile' : ''}`} />

                {editAllowed ? (
                    <EditComponent pageName="disciplines" editParams={editParams} />
                ) : null}
                {scoreData && scoreData.baseScoreBreakdown && (
                    <div className={css.matchingContainer}>
                        <ScoreBadge scoreData={scoreData?.baseScoreBreakdown?.diciplineScore} />
                    </div>
                )}
            </h2>

            <div>
                <div className={css.dBoxes}>
                    {options.map(
                        (
                            {
                                isMain,
                                label,
                                level,
                                title,
                                extraValuesOptionsAvailable,
                                extraValuesOptions,
                            },
                            i
                        ) => (
                            <div className={css.dBox} key={title}>
                                <div className={css.boxTitle}>
                                    <div className={css.subTitle}>
                                        <FormattedMessage
                                            id={`SectionDisciplines.titleLabel-${
                                                isMain ? 'main' : 'secondary'
                                            }`}
                                        />
                                    </div>
                                    <p>{title}</p>
                                </div>
                                <div className={css.boxChips}>
                                    <div className={css.subTitle}>
                                        <FormattedMessage
                                            id={`SectionDisciplines.chipsLabel${
                                                isMobile ? 'Mobile' : ''
                                            }`}
                                        />
                                    </div>
                                    <div
                                        className={css.infoContainer}
                                        onMouseEnter={() => setHoveredIndex(i)}
                                        onMouseLeave={() => setHoveredIndex(null)}
                                    >
                                        <ProgressBarLevels
                                            level={Number(level)}
                                            editAvailable={false}
                                            total={4}
                                        />
                                        {hoveredIndex == i && label && (
                                            <>
                                                <div className={css.infoBalloon}>{label}</div>
                                                <div className={css.balloonArrow} />
                                            </>
                                        )}
                                    </div>
                                </div>
                                {extraValuesOptionsAvailable && (
                                    <div className={css.boxExtra}>
                                        <div className={css.subTitle}>
                                            <FormattedMessage id="SectionDisciplines.extraLabel" />
                                        </div>
                                        <ul>
                                            {extraValuesOptions.map((ev, i) => (
                                                <li key={i}>{ev}</li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

export default SectionDisciplines;
